import clx from 'classnames'
import styles from './ToolTip.css'

const ToolTip = props => {
  const { children, className } = props
  return (
    <div
      className={clx(
        styles.tooltipBlock,
        className
      )}
    >
      {children}
    </div>
  )
}

export default ToolTip
